<template>
  <button class="button button--close" title="Otwórz / zamknij">
    <svg
      class="svg"
      :class="{ 'svg--bcg': color === 'bcg' }"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 298.667 298.667"
      style="enable-background:new 0 0 298.667 298.667;"
      xml:space="preserve"
    >
      <polygon
        points="298.667,30.187 268.48,0 149.333,119.147 30.187,0 0,30.187 119.147,149.333 0,268.48 30.187,298.667
        149.333,179.52 268.48,298.667 298.667,268.48 179.52,149.333"
      />
    </svg>
  </button>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'white'
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  @include reset-button;
  padding: 20px;

  &:hover .svg,
  &:focus .svg {
    transform: rotate3d(0, 0, 1, 90deg);
  }

  position: absolute;
  right: 25px;
  top: 60px;

  @include media-down(lg) {
    top: 30px;
    right: 25px;
  }

  @include media-down(md) {
    top: 10px;
    right: 1px;
  }
}

.svg {
  fill: $text-color;
  transition: transform 0.25s;
  transform-origin: center;

  width: 50px;

  @include media-down(xl) {
    width: 40px;
  }

  @include media-down(lg) {
    width: 45px;
  }

  @include media-down(md) {
    width: 20px;
  }

  &--bcg {
    fill: $background-color;
  }
}
</style>
